import { styled } from "@mui/material";

export const CardStyled = styled("div")`
	position: relative;
	background-color: #fff;
	border-radius: 1rem;
	padding: 1rem;
	box-shadow: 2px 5px 4px 1px rgba(0, 0, 0, 0.1);
	width: 240px;
	display: grid;
	grid-template-rows: max-content;
	gap: 0.5rem;
	text-align: center;

	&.landscape {
		width: ${process.env.REACT_APP_WITH_DEBUG === "true" ? "180px" : "240px"};
	}

	&.mobile {
		height: 230px;

		.title {
			font-size: 1rem;
		}

		.body {
			display: flex;
			flex-direction: column;
			gap: 0.2rem;
		}

		.description {
			line-height: 20px;
			font-size: 14px;
		}
	}
`;

export const ImagesContainer = styled("div")`
	position: relative;
	display: flex;
`;

export const Img = styled("img")`
	width: 100%;
	height: auto;
	object-fit: cover;
	border-radius: 1rem;
`;

export const Img2 = styled("img")`
	position: absolute;
	z-index: 1;
	top: 53%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 55%;
	height: auto;
	object-fit: cover;
	border-radius: 1rem;
`;

export const Body = styled("div")``;

export const Title = styled("h3")`
	font-family: "Baloo";
	font-size: 17px;
	font-weight: 400;
	line-height: 22px;
	color: #113b62;
	margin: 0;
`;

export const Description = styled("p")`
	font-size: 12px;
	line-height: 18px;
	font-weight: 400;
	margin: 0;
`;
